import React from 'react';
import BigHeader from '../components/BigHeader';
import Image from 'react-bootstrap/Image'
import Container from 'react-bootstrap/Container'
import Stack from 'react-bootstrap/Stack'


const Home = () => {
    return (
        <div>
            <BigHeader headerText={"Lubritect"} backgroundImage={"https://static.igem.wiki/teams/4602/wiki/images/images/background.jpg"}/>
            <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <iframe title="Paris-Bettencourt: Lubritect: lubricating protection against STIs (2023) - Project Promotion [English]" width="100%" height="100%" src="https://video.igem.org/videos/embed/c8fd178a-f260-477d-9fb3-3e63b35daec3" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
      </div>
            <p style={{paddingTop: '15px', paddingLeft: '100px', paddingRight: '100px'}} className="fs-2 text-center">Around the world, more than 1 million people are newly infected with sexually transmitted infections each day</p>
            <Container style={{paddingLeft: '100px', paddingRight: '100px'}}>

            <Image  fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/1000000.png"}></Image>

            </Container>

            <Stack direction="horizontal" style={{paddingLeft: '100px', paddingRight: '100px'}}>

            <p  style={{minWidth: '400px'}} className="fs-2 text-left">Over the last 40 years, massive efforts have been devoted to develop prevention and protection methods, such as vaccines and antiretroviral drugs.</p>

            <Image style={{width:'500px'}} fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/elements.jpg"}></Image>

            </Stack>
            <Stack direction="horizontal" style={{paddingLeft: '100px', paddingRight: '100px'}}>


            <Image style={{width:'500px'}} className='ms-auto' fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/condom-munching-clip-001.gif"}></Image>
            <p  style={{minWidth: '400px'}} className="fs-2 text-left">However to date, the most effective and recommended solution against most STIs, are still condoms.</p>

            </Stack>
            <Stack direction="horizontal" style={{paddingLeft: '100px', paddingRight: '100px'}}>


            <p  style={{minWidth: '400px'}} className="fs-2 text-left">But condoms are not always effective → typically, they do not offer much protection against HPV, for example (reference)</p>
            <Image style={{width:'500px'}} className='ms-auto' fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/hpv-26hsv.png"}></Image>

            </Stack>    
            <p style={{paddingTop: '15px'}} className="fs-2 text-center">So complementary, empowering, alternatives are more than necessary. </p>
            <p style={{paddingTop: '15px'}} className="fs-2 text-center">This is where<b className="fs-2 text-center"> our solution </b>comes in</p>
            <Image  fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/lube.png"}></Image>
            <p  style={{paddingLeft: '100px', paddingRight: '100px'}} className="fs-2 text-center">We want to make a biomanufacturable and modular lubricant which can drastically reduce the rate of STI transmission. How?

                We combine two ingredients: 

                (de novo) AI-generated binding proteins against major STI pathogens.</p>
        <Image  fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/ai.gif"}></Image>
        <p style={{paddingLeft: '100px', paddingRight: '100px'}} className="fs-2 text-center">and a biological lubricant, which has a mesh-like molecular structure

            Combined, we generate a sticky net which effectively traps and immobilizes targeted pathogens, preventing them from interacting and infecting our own precious cells.</p>
        
            <Image  fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/stuck.gif"}></Image>
            <Stack direction="horizontal">

            <Image style={{width:'200px'}} fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/red.jpg"}></Image>


            <p  className="fs-2 text-center">As a proof of concept, we have been focused on providing protein binders for HPV and T4 phages.</p>
            <Image style={{width:'200px'}}  fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/phag.jpg"}></Image>

            </Stack>  
            <p style={{paddingTop: '25px'}} className="fs-2 text-center">But there is some really good news - lubes are already widely used!</p>

            <Image fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/wave.png"}></Image>
            <p  style={{paddingTop: '15px' , paddingLeft: '100px', paddingRight: '100px'}} className="fs-2 text-center">Our work provides the user with a product that simultaneously acts as a sexual pleasure-increasing lubricant, and a medical device, limiting the spread of sexually transmitted infections.</p>
            <Container style={{paddingLeft: '100px', paddingRight: '100px'}}>

            <Image fluid src={"https://static.igem.wiki/teams/4602/wiki/images/images/safe-sex.png"}></Image>
            </Container>
            <p style={{paddingTop: '35px' , paddingLeft: '100px', paddingRight: '100px'}} className="fs-2 text-center">By bringing science to the bedroom, we hope to create a game-changer for safe sex, empowering everyone to choose when and how they want to be protected.</p>

        </div>

    )
}
export default Home;
